import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardMedia, CardContent, CardActions, Typography, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { isMVP } from '../config/features';

const PoojaCard = ({ pooja }) => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const handleViewDetails = () => {
        const queryId = pooja.id || pooja.sl_no || '';
        navigate(`/pooja-details?id=${queryId}`, { state: pooja });
    };

    const handleDialogClose = () => setOpen(false);
    const handleDialogOpen = () => setOpen(true);

    return (
        <Card sx={{
            boxShadow: 3,
            borderRadius: 2,
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '380px',
        }}>
            <CardMedia
                component="img"
                height="200"
                image={pooja.Image || 'https://via.placeholder.com/300'}
                alt={pooja.pooja_name || 'Pooja Image'}
            />
            <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" gutterBottom sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 'auto' }}>
                    {pooja.pooja_name}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ height: '60px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {pooja.description || 'No description available.'}
                </Typography>
                <Button
                    onClick={handleDialogOpen}
                    sx={{ textTransform: 'none', marginTop: '10px' }}
                >
                    More Info
                </Button>
                {!isMVP && (
                    <Typography variant="body1" sx={{ marginTop: '10px', fontWeight: 'bold' }}>
                        Starting Price: ₹{pooja.price_economy ? parseInt(pooja.price_economy.split('+')[0]) || 'On Call Quotation' : 'On Call Quotation'}
                    </Typography>
                )}
            </CardContent>
            <CardActions sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 'auto' }}>
                <Button variant="contained" color="error" size="small" onClick={handleViewDetails}>
                    View Details & Book
                </Button>
            </CardActions>

            {/* Dialog for More Info */}
            <Dialog open={open} onClose={handleDialogClose} maxWidth="md" fullWidth>
                <DialogTitle>{pooja.pooja_name}</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" paragraph>{pooja.description || 'No description available.'}</Typography>
                    {pooja.important_findings && (
                        <Typography variant="body2" paragraph><strong>Important Findings:</strong> {pooja.important_findings}</Typography>
                    )}
                    {pooja.what_we_assure_you_of && (
                        <Typography variant="body2" paragraph><strong>What We Assure You Of:</strong> {pooja.what_we_assure_you_of}</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Card>
    );
};

export default PoojaCard;
